<template>
  <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="popupOpened = false">
    <f7-page>
      <f7-navbar title="Оценка">
        <f7-nav-right>
          <f7-link @click="close">
            <f7-icon ios="f7:multiply" aurora="f7:multiply" md="material:close"></f7-icon>
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <f7-block id="ratingData">
        <p class="text-align-center">Оцените качество услуг</p>
        <f7-block-title class="text-align-center">{{
            dateFormat(
              order.data[key].attributes.day,
              order.data[key].attributes.time
            )
        }}
        </f7-block-title>
        <p class="text-align-center" style="margin-top: -14px">
          {{ total_service }} /
          {{ getCar(order.data[key].relationships.cars.data, order.included) }}
        </p>
        <h1 class="text-align-center">{{ total_price }} ₽</h1>

        <div id="app_rating">
          <div class="rating">
            <div v-if="hasCounter" class="info counter">
              <span class="score-rating">{{ stars }}</span>
              <span class="divider">/</span>
              <span class="score-max">{{ maxStars }}</span>
            </div>
            <ul class="list">
              <li @click="rate(star)" v-for="star in maxStars" :class="{ active: star <= stars }" :key="star.stars"
                class="star">
                <i :class="star <= stars ? 'f7-icons' : 'f7-icons'">star_fill</i>
              </li>
            </ul>
            <p class="text-align-center" v-show="errRating" style="
                font-size: var(--f7-input-error-font-size);
                line-height: var(--f7-input-error-line-height);
                color: var(--f7-input-error-text-color);
                font-weight: var(--f7-input-error-font-weight);
                box-sizing: border-box;
              ">
              поставьте оценку
            </p>
          </div>
        </div>
        <f7-list no-hairlines-md>
          <f7-list-input type="text" name="comment" placeholder="Ваш комментарий..." clear-button
            @input="name = $event.target.value"></f7-list-input>
        </f7-list>
        <f7-row>
          <f7-col>
            <f7-button round @click="checkForm" :disabled="disabled" raised fill>Готово</f7-button>
          </f7-col>
          <!-- <f7-col>
              <f7-button raised>Позже</f7-button>
            </f7-col> -->
        </f7-row>
      </f7-block>
    </f7-page>
  </f7-popup>
</template>
<script>
export default {
  name: "Rating",
  props: ["grade", "maxStars", "hasCounter"],
  data() {
    return {
      stars: this.grade,
      errRating: false,
      order: {
        data: [
          {
            type: "orders",
            id: "4230",
            attributes: {
              day: "2021-04-20",
              time: "11:00:00",
              status: "",
              rating: "",
              comment: "",
            },
            meta: { record: "" },
            relationships: {
              costs: { data: [{ type: "costs", id: "1" }] },
              cars: { data: [{ type: "cars", id: "1" }] },
            },
          },
        ],
        included: [
          {
            type: "costs",
            id: "1",
            attributes: {
              title: "",
              body: "",
              price: 0,
              discount: 0,
              total: 0,
              duration: "0",
            },
          },
          {
            type: "cars",
            id: "1",
            attributes: {
              carBrand: "",
              stateNumber: "",
              category: "",
              color: "",
            },
          },
        ],
      },
      total_price: 0,
      total_service: "",
      order_id: 0,
      comment_before: "",
      key: 0,
      popupOpened: false,
      disabled: false,
    };
  },
  methods: {
    rate(star) {
      if (typeof star === "number" && star <= this.maxStars && star >= 0) {
        this.stars = this.stars === star ? star - 1 : star;
        this.stars = star == 0 ? 1 : star;
      }
      this.$root.rating = star;
      this.disabled = false;
      this.errRating = false;
    },
    close() {
      if (this.comment_before == "Закрыл") {
        this.ratings(0, "Отказался", false);
      } else {
        this.ratings(0, "Закрыл", false);
      }
      this.popupOpened = false;
    },
    ratings(rating, comment, show = true) {
      this.$f7ready((f7) => {
        let that = this;
        let post = {
          data: [
            {
              type: "ratings",
              id: "1",
              attributes: {
                value: rating,
                comment: comment,
              },
              relationships: {
                orders: {
                  data: {
                    type: "orders",
                    id: this.order_id,
                  },
                },
              },
            },
          ],
        };
        console.log(post);
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/ratings",
          method: "POST",
          dataType: "json",
          data: JSON.stringify(post),
          success: function (data, status) {
            if (data.data != null && show) {
              var toast = f7.toast.create({
                icon: '<i class="f7-icons">checkmark_seal</i>',
                text: `Спасибо за оценку!`,
                position: "center",
                closeTimeout: 4000,
              });
              toast.open();
              that.popupOpened = false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            that.disabled = false;
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    checkForm(check = true) {
      this.disabled = true;
      var formData = this.$f7.form.convertToData("#ratingData");
      console.log("ratingData");
      console.log(formData);
      var comment = formData.comment;
      var rating = this.$root.rating;
      console.log(rating);
      if (typeof rating == "undefined") {
        this.errRating = true;
        return false;
      } else {
        this.errRating = false;
        this.ratings(rating, comment);
      }
    },
    getOrders() {
      this.$f7ready((f7) => {
        let that = this;
        let days = [];

        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/orders",
          method: "GET",
          dataType: "json",
          data: "",
          success: function (data, status) {
            that.preloader = false;
            if (data.data.length > 0) {
              that.order = data;
              that.orders = data;
              data.data.forEach(function (order, key) {
                if (
                  // true
                  order.attributes.status == "Выполнен" &&
                  order.attributes.rating == "0" &&
                  (order.attributes.comment == "" ||
                    order.attributes.comment == "Закрыл")
                ) {
                  var i = 0;
                  var services = [];
                  that.total_price = 0;
                  that.key = key;
                  order.relationships.costs.data.forEach(function (cost) {
                    data.included.forEach(function (included) {
                      if (
                        included.id == cost.id &&
                        included.type == cost.type
                      ) {
                        that.total_price += parseInt(included.attributes.total);
                        services[i] = included.attributes.title;
                        i++;
                      }
                    });
                    that.total_service = services.join(", ");
                    that.order_id = order.id;
                    that.comment_before = order.attributes.comment;
                    that.popupOpened = true;
                  });
                }
              });
              that.$root.count = 0;
              data.data.forEach(function (entry) {
                if (entry.attributes.status == "В записи") {
                  that.$root.count++;
                }
              });
              return true;
            } else {
              that.isEnable = true;
              return false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    getCar(data, included) {
      let list = [];
      //console.log(included);
      data.forEach(function (car) {
        included.forEach(function (cars) {
          if (car.id == cars.id) {
            list.push(
              cars.attributes.carBrand + ", " + cars.attributes.stateNumber
            );
          }
        });
      });
      return list.join(", ");
    },
    dateFormat(date, time, format = 0) {
      function appendLeadingZeroes(n) {
        if (n <= 9) {
          return "0" + n;
        }
        return n;
      }
      const months = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
      var now = new Date();
      let current_datetime = new Date(date + "T" + time + "+05:00");
      let year =
        now.getFullYear() == current_datetime.getFullYear()
          ? ""
          : " " + current_datetime.getFullYear();
      let formatted_date0 =
        current_datetime.getDate() +
        " " +
        months[current_datetime.getMonth()] +
        year +
        ", " +
        appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        appendLeadingZeroes(current_datetime.getMinutes());

      let formatted_date1 =
        current_datetime.getDate() +
        " " +
        months[current_datetime.getMonth()] +
        year +
        " в " +
        appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        appendLeadingZeroes(current_datetime.getMinutes());

      return format == 0 ? formatted_date0 : formatted_date1;
    },
    checkReg() {
      var user =  JSON.parse(localStorage.getItem("user"));
      if (
        localStorage.getItem("token") !== null &&
        user !== null && user.name !== ''
      ) {
        return true;
      } else {
        // localStorage.removeItem("user");
        // localStorage.removeItem("token");
        // localStorage.removeItem("isSmsSend");
        return false;
      }
    },
  },
  mounted: function () {
    if (this.checkReg()) {
      this.getOrders();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">
@import "../css/rating.css";
</style>